/*
  This component prevents images being loaded until you hover on the section that contains the <deferred-media> element.
  It simply removes the class "hidden" from the <deferred-media> element and allows the browser to download the image inside it.

  Usage:
    <deferred-media class="hidden">
      // Insert image markup here:
      {%- render 'image'... -%}
    </deferred-media>
*/
export default class DeferredImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const section = this.closest('.shopify-section');

    section.addEventListener(
      'mouseover',
      () => {
        this.classList.remove('hidden');
      },
      {once: true}
    );
  }
}
